// Shared by page-speed and form diagnostics. No cookies or persistent IDs.
const trialEndsAt = Date.parse("2026-10-29T00:00:00Z")
const consentEvents = [
  "CookieScriptLoaded",
  "CookieScriptAcceptAll",
  "CookieScriptAccept",
  "CookieScriptReject",
  "CookieScriptCurrentState",
]

const hasAnalyticsConsent = (browser) => {
  try {
    const state = browser.CookieScript.instance.currentState()
    return (
      state.action === "accept" &&
      Array.isArray(state.categories) &&
      state.categories.includes("performance")
    )
  } catch (_) {
    return false
  }
}

const isTrialSampled = (browser, random = Math.random) => {
  if (typeof browser.__expendPerformanceSample !== "boolean")
    browser.__expendPerformanceSample = random() < 0.1
  return browser.__expendPerformanceSample
}

module.exports = {
  trialEndsAt,
  consentEvents,
  hasAnalyticsConsent,
  isTrialSampled,
}
